import { clsx } from 'clsx';

import { CardProps } from '@monoimin/sb-types';

import { Card } from './Card';

type CardsCollectionProps = {
  items: Array<CardProps>;
  classNames?: {
    container?: string;
    largeCard?: CardProps['classNames'];
    smallCard?: CardProps['classNames'];
  };
  prioritizeFirst?: boolean;
  isListView?: boolean;
};

export const CardsCollection = ({
  items,
  classNames,
  prioritizeFirst,
  isListView,
}: CardsCollectionProps) => {
  const propsForCollection = items.slice(0, 5);

  const firstCardProps = propsForCollection[0];

  const updatedFirstCardProps = {
    ...firstCardProps,
    priority: prioritizeFirst || firstCardProps?.priority,
  };
  return (
    <div className={clsx('flex flex-col gap-12', classNames?.container)}>
      <div className='flex flex-col lg:flex-row gap-12'>
        {!isListView && (
          <Card
            {...updatedFirstCardProps}
            variant='custom'
            classNames={{
              ...classNames?.largeCard,
              container: 'w-full lg:w-7/12 flex-col',
              title: 'h2',
              content: 'pt-5 md:pt-7',
            }}
            sizes='(max-width: 768px) 95vw, 640px'
          />
        )}
        <div
          className={clsx('flex flex-col divide-y divide-line', {
            'lg:w-full': isListView,
            'lg:w-5/12': !isListView,
          })}
        >
          {propsForCollection.map((item, index) => {
            if (index === 0 && !isListView) {
              return null;
            }
            const updatedItem = { ...item, prefetch: index < 2 };
            return (
              <Card
                {...updatedItem}
                key={item.url}
                variant='custom'
                classNames={{
                  ...classNames?.smallCard,
                  container:
                    'flex-row-reverse h-fit self-start py-5 first:pt-0 last:pb-0',
                  image: 'w-32 h-32',
                  title: 'body',
                  content: 'pr-2',
                  footer: 'hidden',
                  description: isListView ? '' : 'hidden',
                }}
                sizes='128px'
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default CardsCollection;
